import { MeterColumn, MeterColumnConfig, MeterSensorType } from '@contracts';
import {
  DEFAULT_ENERGY_METER_COLUMNS,
  DEFAULT_WATER_METER_COLUMNS,
} from '@feature/meter';

export function resolveMeterColumns(
  config: MeterColumnConfig | null | undefined,
  sensorType: MeterSensorType,
  module: string | null,
): MeterColumn[] {
  if (sensorType === 'water') {
    return config?.water?.length
      ? config.water.filter((c) => c.visible !== false)
      : DEFAULT_WATER_METER_COLUMNS;
  }

  const defaults = DEFAULT_ENERGY_METER_COLUMNS;

  if (!config?.energy || !module) {
    return defaults;
  }
  const moduleColumns = config.energy[module.toLowerCase()];

  return moduleColumns?.length
    ? moduleColumns.filter((c) => c.visible !== false)
    : defaults;
}
